import { auth } from "../firebase";

let installed = false;

function isProtectedRequest(url: string) {
  if (typeof window === "undefined") return false;
  return url.startsWith("/api/") ||
    url.startsWith(`${window.location.origin}/api/`) ||
    url.startsWith("/uploads/") ||
    url.startsWith(`${window.location.origin}/uploads/`);
}

export function installAuthenticatedFetch() {
  if (installed || typeof window === "undefined") {
    return;
  }

  installed = true;
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const requestUrl =
      typeof input === "string"
        ? input
        : input instanceof URL
          ? input.toString()
          : input.url;

    if (!isProtectedRequest(requestUrl)) {
      return originalFetch(input, init);
    }

    const headers = new Headers(input instanceof Request ? input.headers : init?.headers);

    if (!headers.has("Authorization") && auth.currentUser) {
      try {
        const idToken = await auth.currentUser.getIdToken();
        headers.set("Authorization", `Bearer ${idToken}`);
      } catch (error) {
        console.error("Failed to attach Firebase ID token to request", error);
      }
    }

    if (input instanceof Request) {
      return originalFetch(new Request(input, { ...init, headers }));
    }

    return originalFetch(input, { ...init, headers });
  };
}
